export default [
  {
    id: 'f1-id',
    value: '1',
    label: '1',
    tracking: 'ga-search-form-toggle-1-bedroom',
    cy: 'rooms-1'
  },
  {
    id: 'f2-id',
    value: '2',
    label: '2',
    tracking: 'ga-search-form-toggle-2-bedroom',
    cy: 'rooms-2'
  },
  {
    id: 'f3-id',
    value: '3',
    label: '3',
    tracking: 'ga-search-form-toggle-3-bedroom',
    cy: 'rooms-3'
  },
  {
    id: 'f3more-id',
    value: '3more',
    label: '+3',
    tracking: 'ga-search-form-toggle-3more-bedroom',
    cy: 'rooms-3more'
  }
];
